// extracted by mini-css-extract-plugin
export default {"container":"NoAvailability_container__aRs8y"};